import { Input, Component } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-planning-poker-feature-header",
  templateUrl: "./planning-poker-feature-header.component.html",
  styleUrls: ["./planning-poker-feature-header.component.scss"],
})
export class PlanningPokerFeatureHeaderComponent {
  @Input() feature: any;
  env: any = environment;

  constructor() {}

  getTextColor(backColor) {
    backColor = backColor || "#f5f5f5";
    var color =
      backColor.charAt(0) === "#" ? backColor.substring(1, 7) : backColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.55 ? "#000" : "#fff";
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/planning-poker-feature-header/planning-poker-feature-header.component.ts